import * as Highcharts from 'highcharts';
import { Target } from '../types/chartData';
import { targetLineDefaults } from './chartDefaults';
import { escapeHtml } from '@opengov/reporting-types/src/escapeHtml';

export function renderLabelForPlotLine(targetInfo: Target) {
  return `<b>${escapeHtml(targetInfo.title)}</b><br/>${escapeHtml(targetInfo.subTitle)}`;
}

export function getPlotLinesForVerticalBaseChart(targets: Target[]): Highcharts.YAxisPlotLinesOptions[] {
  const isFirst = (index: number) => index === 0;

  return targets.map((target, index) => ({
    ...targetLineDefaults.targetLineStyle,
    value: target.value,
    ...(target.title || target.subTitle
      ? {
          label: {
            text: renderLabelForPlotLine(target),
            align: 'right',
            verticalAlign: index === 0 ? 'top' : 'bottom',
            y: isFirst(index)
              ? -targetLineDefaults.chartLabelOffsets.yLabelTopOffset
              : targetLineDefaults.chartLabelOffsets.yLabelBottomOffset,
            x: 0,
            useHTML: true,
            style: targetLineDefaults.targetLineLabelStyle
          }
        }
      : {})
  }));
}

export function getPlotLinesForHorizontalBaseChart(targets: Target[]): Highcharts.YAxisPlotLinesOptions[] {
  const isFirst = (index: number) => index === 0;

  return targets.map((target, index) => ({
    ...targetLineDefaults.targetLineStyle,
    value: target.value,
    ...(target.title || target.subTitle
      ? {
          label: {
            text: renderLabelForPlotLine(target),
            align: isFirst(index) ? 'left' : 'right',
            verticalAlign: 'top',
            y: 0,
            x: isFirst(index)
              ? targetLineDefaults.chartLabelOffsets.xLabelOffset
              : -targetLineDefaults.chartLabelOffsets.xLabelOffset,
            useHTML: true,
            rotation: 0,
            style: targetLineDefaults.targetLineLabelStyle
          }
        }
      : {})
  }));
}

export function getPlotLines(
  targets: Target[],
  chartType?: Highcharts.ChartOptions['type']
): Highcharts.YAxisPlotLinesOptions[] {
  if (chartType === 'column' || chartType === 'line') {
    return getPlotLinesForVerticalBaseChart(targets);
  }
  if (chartType === 'bar') {
    return getPlotLinesForHorizontalBaseChart(targets);
  }
  return [];
}
